// Banner del modo "Ver como" — barra fija inferior visible en TODA pantalla de
// la suplantación. Deja claro a quién se está viendo (persona · rol · planta),
// en solo lectura, y permite CAMBIAR de persona/rol o SALIR. Se monta una sola
// vez en el router.
//
// Barra INFERIOR (no superior): un solo punto de montaje, sin cirugía en los
// layouts h-screen de cada rol.

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { Button } from '../../../components/ui/button';
import { Dialog } from '../../../components/ui/dialog';
import { useVerComo, type DestinoVerComo } from '../../../lib/ver-como';
import { VerComoModalContent } from './VerComoLanzador';

const DESTINO_LABEL: Record<DestinoVerComo, string> = {
  coordinador: 'Coordinador',
  supervisor: 'Supervisor',
  lider: 'Líder',
  mantenimiento: 'Mantenimiento',
};

export function VerComoBanner() {
  const { estado, salir } = useVerComo();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [cambiar, setCambiar] = useState(false);

  if (!estado) return null;

  const partes = [
    estado.nombre || DESTINO_LABEL[estado.destino],
    DESTINO_LABEL[estado.destino],
    estado.plantaLabel ?? 'todas las plantas',
  ].filter(Boolean);

  function handleSalir() {
    salir();
    // Refetch total: vuelve a la vista del propio directivo sin el header.
    queryClient.clear();
    navigate('/directivo', { replace: true });
  }

  return (
    <>
      <div
        role="status"
        className="fixed inset-x-0 bottom-0 z-[60] border-t border-warn/40 bg-warn-soft/95 backdrop-blur"
        style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      >
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-2">
          <p className="flex min-w-0 items-center gap-2 text-xs text-fg">
            <span className="inline-flex size-2 shrink-0 rounded-full bg-warn" aria-hidden />
            <span className="min-w-0 truncate">
              <span className="font-medium text-warn">Viendo como</span>{' '}
              <span className="font-medium">{partes.join(' · ')}</span>{' '}
              <span className="text-fg-secondary">· solo lectura</span>
            </span>
          </p>
          <div className="flex shrink-0 items-center gap-2">
            <Button size="sm" variant="ghost" onClick={() => setCambiar(true)}>
              Cambiar
            </Button>
            <Button size="sm" variant="secondary" onClick={handleSalir}>
              Salir del modo
            </Button>
          </div>
        </div>
      </div>
      <Dialog open={cambiar} onClose={() => setCambiar(false)}>
        <VerComoModalContent open={cambiar} onClose={() => setCambiar(false)} />
      </Dialog>
    </>
  );
}
